import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'drdp-drdp-layout',
    templateUrl: './drdp-layout.component.html',
    styleUrls: ['./drdp-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrdpLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
